import {Roles} from 'app/Constants';
import IntegrityRoleGrid from 'components/UserRole';
import {Column} from 'devextreme-react/data-grid';
import {i18n2} from 'features/i18n/i18n';
import React from 'react';
import {useIntegrityProfCourse} from '../hooks';

const ProfCourseGrid = (props: any) => {
  const loadProfCourse = useIntegrityProfCourse(props.data.key);
  return (
    <IntegrityRoleGrid
      allowEdit={Roles.AdminITPS}
      dataSource={loadProfCourse}
      id={['iD_Course', 'iD_ProfileSpac']}
      height={'30vh'}
      allowIntegrity={false}
      disabledExport={true}
      autoWidth={false}
      allowActions={false}
    >
      <Column
        caption={i18n2._('#Curso')}
        hidingPriority={0}
        dataField="iD_Course"
      />
      <Column caption={i18n2._('Curso')} dataField="name_Course" />
      <Column caption={i18n2._('Perfil Spac')} dataField="iD_ProfileSpac" />
      <Column caption={i18n2._('SPAC')} dataField="spac" />
      <Column caption={i18n2._('Nombre del SPAC')} dataField="name_Spac" />
      <Column caption={i18n2._('Perfil Spac')} dataField="name_ProfSpac" />
      <Column caption={i18n2._('Revision')} dataField="revision" />
      <Column caption={i18n2._('Motivo')} dataField="reason" />
      <Column
        caption={i18n2._('Fecha de actualizacion')}
        dataField="updateDate"
        defaultSortOrder={'desc'}
      />
      <Column caption={i18n2._('Actualizado por')} dataField="updatedBy" />
      <Column caption={i18n2._('Eliminado')} dataField="deleted" width={100} />
    </IntegrityRoleGrid>
  );
};

export default ProfCourseGrid;
